<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="modal-window-content">
    <div class="siklu-mat-dialog-title" matDialogTitle>
        <h4>Import Topology</h4>
        <button (click)="closeModal()" matDialogClose windeClose>
            <sui-svg-icon icon="cross" />
        </button>
    </div>
    <div class="siklu-mat-dialog-body" matDialogContent>
        <div class="row no-gutters">
            <label class="custom-file custom-file--uploader">
                <input
                    (change)="fileChange($event)"
                    [(ngModel)]="fileInp"
                    accept=".xlsx, .kml, .kmz"
                    class="custom-file-input"
                    id="imgFile"
                    placeholder="Upload file"
                    type="file"
                />
                <span class="custom-file-label">{{ file ? file.name : 'Choose file' }}</span>
                <small class="d-block form-text text-muted">* Supported file extensions - xlsx, kml, kmz</small>
            </label>
        </div>
    </div>
    <div class="siklu-mat-dialog-footer" matDialogActions>
        <button (click)="downloadTemplate()" [disabled]="!file || isImporting" windeGreen>Upload File</button>
    </div>
</div>
